import { Box, Stack, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";

const Sidebar = ({ selected = "estandares" }) => {
    const router = useRouter();
    const [scrollDownLimit, setScrollDownLimit] = useState(0);

    const onScroll = useCallback((event) => {
        const { scrollY, innerHeight } = window;
        const bodyHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
        );
        const max_scroll = bodyHeight - innerHeight;
        const scroll_point = max_scroll - scrollY - 150; //Footer
        setScrollDownLimit(scroll_point > 1 ? scroll_point : 0);
    }, []);

    useEffect(() => {
        //add eventlistener to window
        window.addEventListener("scroll", onScroll, { passive: true });
        // remove event on unmount to prevent a memory leak with the cleanup
        return () => {
            window.removeEventListener("scroll", onScroll, { passive: true });
        };
    }, []);

    return (
        <>
            <Stack gap={6} pt={10} mt={16} pr={4} minW={{ base: "100%", md: "20%" }}>
                <Box
                    position={scrollDownLimit === 0 ? "sticky" : "fixed"}
                    top={{ base: 20, md: 40 }}
                    bg="white"
                    w={{ base: "100%", md: "auto" }}
                    py={4}
                >
                    <Box
                        cursor="pointer"
                        onClick={() => router.push("/estandares-de-conducta")}
                        borderLeft={selected === "estandares" ? "4px solid #005895" : "none"}
                        mb={2}
                    >
                        <Text
                            color="#005895"
                            fontWeight={selected === "estandares" ? "700" : "400"}
                            ml={2}
                        >
                            Estándares de conducta
                        </Text>
                    </Box>
                    <Box
                        cursor="pointer"
                        onClick={() => router.push("/codigo-de-etica")}
                        borderLeft={selected === "codigo" ? "4px solid #005895" : "none"}
                    >
                        <Text
                            color="#005895"
                            fontWeight={selected === "codigo" ? "700" : "400"}
                            ml={2}
                        >
                            Código de ética
                        </Text>
                    </Box>
                </Box>
            </Stack>
        </>
    );
};

export default Sidebar;
